import { render, staticRenderFns } from "./download-attachments-modal.vue?vue&type=template&id=342ed612"
import script from "./download-attachments-modal.ts?vue&type=script&lang=ts&external"
export * from "./download-attachments-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./download-attachments-modal.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('342ed612')) {
      api.createRecord('342ed612', component.options)
    } else {
      api.reload('342ed612', component.options)
    }
    module.hot.accept("./download-attachments-modal.vue?vue&type=template&id=342ed612", function () {
      api.rerender('342ed612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-input/download-attachments-modal/download-attachments-modal.vue"
export default component.exports